import Sensors from '@mui/icons-material/Sensors'
import SensorsOff from '@mui/icons-material/SensorsOff'
import { Badge, Box, IconButton, SxProps, Theme, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useCFDContext } from 'pages/CustomerFacingDisplayPage/context/useCFDContext'
import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled'
import { useHistory } from 'react-router-dom'
import { CFDROUTE } from 'pages/CustomerFacingDisplayPage/CFDLayout'

const sensorIcon: SxProps<Theme> = {
    fontSize: '28px',
}

function CFDHWAgentStatusIcon() {
    const { t } = useTranslation()
    const { isHWOnline, isConnected, onDisconnectedToPOS } = useCFDContext()
    const history = useHistory()
    const goToHWAgentSetting = () => {
        onDisconnectedToPOS()
        history.push(CFDROUTE.HW_SETTING)
    }

    if (history.location.pathname === CFDROUTE.HW_SETTING) return null
    return isHWOnline ? (
        <Box display="flex" alignItems="center">
            {!isConnected ? (
                <IconButton color="inherit">
                    <Badge
                        badgeContent={
                            <DesktopAccessDisabledIcon sx={{ width: 12 }} />
                        }
                        color="error"
                    >
                        <Sensors sx={sensorIcon} />
                    </Badge>
                </IconButton>
            ) : (
                <Sensors sx={sensorIcon} />
            )}
        </Box>
    ) : (
        <Tooltip
            onClick={goToHWAgentSetting}
            title={t('hwAgent.cannot_find_hwagent_run_on_your_system')}
        >
            <SensorsOff />
        </Tooltip>
    )
}

export default CFDHWAgentStatusIcon
